/**
 * DUNAMIS WEAR — Modal System
 * Usa dialog.showModal() para garantir top-layer (acima de WhatsApp, vídeo, captcha, etc.)
 */
(function () {
  'use strict';
  const theme = window.theme || (window.theme = {});

  function openModal(id) {
    const modal = document.getElementById(id);
    if (!modal) return;

    if (typeof modal.showModal === 'function' && !modal.open) {
      try {
        modal.showModal();
      } catch (err) {
        modal.setAttribute('open', '');
      }
    } else {
      modal.setAttribute('open', '');
    }

    modal.classList.add('is-open');
    document.documentElement.classList.add('modal-open');
    document.body.style.overflow = 'hidden';
    if (theme.trapFocus) {
      const content = modal.querySelector('.modal__content');
      if (content) theme.trapFocus(content);
    }
  }

  function closeModal(modal) {
    if (!modal) return;

    if (typeof modal.close === 'function' && modal.open) {
      try {
        modal.close();
      } catch (err) {
        modal.removeAttribute('open');
      }
    } else {
      modal.removeAttribute('open');
    }

    modal.classList.remove('is-open');

    if (!document.querySelector('.modal.is-open, dialog[open]')) {
      document.documentElement.classList.remove('modal-open');
      document.body.style.overflow = '';
    }
  }

  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-modal-open]');
    if (openBtn) {
      e.preventDefault();
      openModal(openBtn.getAttribute('data-modal-open'));
      return;
    }
    const closeBtn = e.target.closest('[data-modal-close]');
    if (closeBtn) {
      const modal = closeBtn.closest('.modal');
      if (modal) closeModal(modal);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.modal.is-open, dialog.modal[open]').forEach(closeModal);
    }
  });

  document.querySelectorAll('dialog.modal').forEach(function (modal) {
    modal.addEventListener('close', function () {
      modal.classList.remove('is-open');
      if (!document.querySelector('.modal.is-open, dialog[open]')) {
        document.documentElement.classList.remove('modal-open');
        document.body.style.overflow = '';
      }
    });
  });

  theme.openModal = openModal;
  theme.closeModal = closeModal;
})();
